export * from "./hotel-last-second-hotel-page";
export * from "./hotel-last-second-hotel-page.type";
